module.exports = __webpack_public_path__ + "static/media/BlockCities-type-logo.95aabe6b.svg";